import CategorySelect from "@/components/form/category-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a category id** (`string | null`). */
export type CategoryFieldProps = PickerFieldProps<string | null>;

export const CategoryField = makePickerField<string | null>({
  name: "CategoryField",
  control: CategorySelect,
  popout: true,
});
